import React, { Component } from 'react';
import { Panel, Button, Badge, Tabs, Tab } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import EditableTextField from '../../CategoryView/EditableTextField';
import EditableTextArea from '../../CategoryView/EditableTextArea';
import '../../../content/css/PortfolioAnalysis/PortfolioAnalysis.css';

export default class ListCard extends Component {

    handleFilterClick = (contractType) => {
        this.props.onFilterClick(contractType);
    }

    handleButtonClick = () => {
        this.props.onSelectClick(this.props.contractType);
    }

    handleNameChange = (name) => {
        this.props.onNameChange(this.props.id, name);
    }

    handleDescriptionChange = (description) => {
        this.props.onDescriptionChange(this.props.id, description);
    }

    getType = (type) => {
        switch (type) {
            case 0: return "ProcurementAgreement";
            case 1: return "CustomerAgreement";
            case 2: return "Unknown";
            case 3: return "NDA_Customer";
            case 4: return "NDA_Seller";
            case 5: return "NDA_Mutual";
            case 6: return "EULA_Customer";
            case 7: return "EULA_Seller";
            case 8: return "DistributionAgreement_Customer";
            case 9: return "DistributionAgreement_Seller";
            case 10: return "DPA_Controller";
            case 11: return "DPA_Processor";
            case 12: return "LicenseAgreement_Customer";
            case 13: return "LicenseAgreement_Seller";
            case 14: return "SourcingOfGoods_Customer";
        }
    }

    getName = (type) => {
        switch (type) {
            case 0: return "Procurement agreement";
            case 1: return "Customer agreement";
            case 2: return "Unknown";
            case 3: return "NDA - receiving information";
            case 4: return "NDA - giving information";
            case 5: return "NDA - giving/receiving information";
            case 6: return "EULA - Customer";
            case 7: return "EULA - Seller";
            case 8: return "Distribution agreement - Customer";
            case 9: return "Distribution agreement - Seller";
            case 10: return "DPA - Controller";
            case 11: return "DPA - Processor";
            case 12: return "License agreement - Customer";
            case 13: return "License agreement - Seller";
            case 14: return "Source of Goods agreement";
        }
    }

    groupByKey = (xs, key) => {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    groupBy = (xs) => {
        return xs.reduce(function (rv, x) {
            (rv[x] = rv[x] || []).push(x);
            return rv;
        }, {});
    };

    ticksToDateString = (ticks) => {
        const ticksPerMillisecond = 10000;
        const epochTicks = 621355968000000000; // number of ticks between .NET epoch (January 1, 0001) and Unix epoch (January 1, 1970)
        let javascriptTimestamp = (ticks - epochTicks) / ticksPerMillisecond;
        let date = new Date(javascriptTimestamp);
        return date.toLocaleDateString();
    }

    renderContractTypes = () => {
        //const contractTypes = Object.entries(this.groupBy(this.props.documents, 'contractType'));
        const contractTypes = Object.entries(this.groupBy(this.props.contractTypes));
        let self = this;
        return contractTypes.map(([type, items]) => (
            <Badge>{self.getName(parseInt(type))}: {items.length}</Badge>
        ));
    }

    render() {
        return (
            <Panel>
                <div className="portfolio-card">
                    <div className="top">
                        <div>
                            <EditableTextField
                                text={this.props.name}
                                viewProps={{
                                    className: 'title'
                                }}
                                onChange={this.handleNameChange}
                            />
                            <span className="uppercase">{this.props.documentCount} documents</span>
                        </div>
                        <p className="uppercase">{this.ticksToDateString(this.props.date)}</p>
                    </div>
                    <EditableTextArea
                        text={this.props.description}
                        onChange={this.handleDescriptionChange}
                    />
                    <hr />
                    <span className="uppercase">This report contains:</span>
                    <div className="tags">
                        {this.renderContractTypes()}
                    </div>
                    <LinkContainer to={`/reports/${this.props.id}`}>
                        <Button>View report</Button>
                    </LinkContainer>
                </div>
            </Panel>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AnalysisReports/PortfolioList/ListCard.js